module.exports = __webpack_public_path__ + "img/td_bg.a5aff44a.png";